import { nonEmptyArray, random } from 'fp-ts';
import { NonEmptyArray } from 'fp-ts/NonEmptyArray';

export const sampleSize = <T>(count: number, collection: NonEmptyArray<T>) => {
    const source = nonEmptyArray.copy(collection);
    const result = [];

    do {
        const indexIO = random.randomInt(0, source.length - 1);
        const index = indexIO();

        result.push(source[index]);
        source.splice(index, 1);
    } while (result.length < count && source.length > 0);

    return result;
};
